const PHONE_E164_REGEX = /^\+[1-9]\d{7,14}$/;

const normalizeString = (value) => (typeof value === 'string' ? value.trim() : '');

const splitDisplayName = (displayName) => {
  const normalized = normalizeString(displayName);
  if (!normalized) {
    return { firstName: '', lastName: '' };
  }

  const parts = normalized.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }

  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' ')
  };
};

export const getInitialCustomerInfo = ({ currentUser, userData }) => {
  const displayName = splitDisplayName(currentUser?.displayName);

  const firstName =
    normalizeString(userData?.first_name) ||
    normalizeString(userData?.firstName) ||
    displayName.firstName;

  const lastName =
    normalizeString(userData?.last_name) ||
    normalizeString(userData?.lastName) ||
    displayName.lastName;

  const phoneNumber =
    normalizeString(userData?.phone_number) ||
    normalizeString(userData?.phone) ||
    normalizeString(currentUser?.phoneNumber);

  return {
    first_name: firstName,
    last_name: lastName,
    phone_number: phoneNumber
  };
};

export const isBillingInfoComplete = (info) => {
  if (!info.first_name || info.first_name.trim() === '') return false;
  if (!info.last_name || info.last_name.trim() === '') return false;
  if (!info.phone_number || !PHONE_E164_REGEX.test(info.phone_number)) return false;
  return true;
};

